(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.CradleLoader = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.CradleLoader = undefined;
  var _react2 = _interopRequireDefault(_react);
  var _propTypes2 = _interopRequireDefault(_propTypes);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var CradleLoader = exports.CradleLoader = function CradleLoader(props) {
    return _react2.default.createElement("div", {
      "aria-label": props.label,
      role: "presentation",
      className: "container"
    }, _react2.default.createElement("div", {
      className: "react-spinner-loader-swing"
    }, _react2.default.createElement("div", {
      className: "react-spinner-loader-swing-l"
    }), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", {
      className: "react-spinner-loader-swing-r"
    })), _react2.default.createElement("div", {
      className: "react-spinner-loader-shadow"
    }, _react2.default.createElement("div", {
      className: "react-spinner-loader-shadow-l"
    }), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", null), _react2.default.createElement("div", {
      className: "react-spinner-loader-shadow-r"
    })));
  };
  CradleLoader.propTypes = {
    label: _propTypes2.default.string
  };
  CradleLoader.defaultProps = {
    label: "audio-loading"
  };
});